import React, { useCallback, useState } from "react";
import { Alert, Card, Collapse, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import logo from "../../assets/logo.png";
import { pb } from "../utils/pocketbase";
import { AuthTokenInput } from "./AuthTokenInput";
import { Button } from "./Button";

interface LoginForm {
  email: string;
  token: string;
}

export const Login = () => {
  const { register, handleSubmit, watch } = useForm<LoginForm>();

  const [requestedOtpId, setRequestedOtpId] = useState<string>();
  const [authError, setAuthError] = useState<string>();
  const [isPending, setIsPending] = useState(false);

  const email = watch("email");

  const verifyOtp = useCallback((token: string) => {
    if (!requestedOtpId) return;

    setIsPending(true);

    pb.collection("users").authWithOTP(requestedOtpId, token)
      .then(() =>
        setRequestedOtpId(undefined)
      )
      .catch(error =>
        setAuthError(error?.message)
      )
      .finally(() => setIsPending(false));
  }, [email, requestedOtpId]);

  const requestOtp = useCallback(({ email }: LoginForm) => {
    setIsPending(true);
    setAuthError(undefined);

    pb.collection("users").requestOTP(email)
      .then(({ otpId }) => setRequestedOtpId(otpId))
      .catch((error) => setAuthError(error.message))
      .finally(() => setIsPending(false));
  }, []);

  return (
    <div className="vh-100 d-flex flex-column justify-content-center align-items-center">
      <img
        src={logo}
        alt="tuc logo"
        width="150"
        className="mb-4"
      />
      <Alert variant="danger" show={Boolean(authError)}>
        {authError}
      </Alert>
      <Card className="shadow" style={{ width: 300 }}>
        <Card.Header>
          Sign In
        </Card.Header>
        <Card.Body>
          <Form className="d-flex flex-column w-100" onSubmit={handleSubmit(requestOtp)}>
            <Form.Control
              className="mb-3"
              disabled={!!requestedOtpId}
              type="email"
              placeholder="name@tu-clausthal.de"
              {...register("email", {
                required: true,
                pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              })}
            />

            <Collapse in={!!requestedOtpId} mountOnEnter>
              <div>
                <Form.Group className="mb-3">
                  <Form.Label>Enter or paste your auth token:</Form.Label>
                  <AuthTokenInput isPending={isPending} length={6} onCompleted={verifyOtp} />
                </Form.Group>
                <Button
                  className="w-100"
                  variant="outline-secondary"
                  onClick={() => setRequestedOtpId(undefined)}
                >
                  Cancel
                </Button>
              </div>
            </Collapse>
            <Collapse in={!requestedOtpId} >
              <div>
                <Button
                  variant="outline-primary"
                  className="w-100"
                  type="submit"
                  spinner={isPending}
                >
                  Send auth token
                </Button>
              </div>
            </Collapse>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}
